<template>
  <DsfViewPart
    class="dsf-form-pick-up"
    ref="viewPart"
    :showModel="showModel"
    :path="path"
    @ready="init"
  ></DsfViewPart>
</template>

<script>
export default dsf.component({
  name: "DsfFormPickUp",
  ctrlCaption: "表单页面拾取代理组件",
  mixins: [$mixins.control],
  props: {
    path: {
      type: String,
      default: "",
    },
    showModel: {
      type: String,
      default: "none",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getMetadataKeyList() {
      return this.$refs?.viewPart?.content?.$page?.$vm?.metadataKeyList || [];
    },
    init() {
      const el = $(this.$el);
      const viewPart = this.$refs.viewPart;
      this.$nextTick(() => {
        el.on("dblclick", this.dblclick);
        let metadataKeyList = this.getMetadataKeyList();
        if (metadataKeyList.length) {
          metadataKeyList.forEach((name) => {
            const vm = $(`.ds-form-item[form-name="${name}"]`)?.[0]?.__vue__;
            if (vm) vm.$emit("update:visible", true);
          });
        }
      });
      //isOneToMany
      this.$dispatch("ready");
    },
    dblclick(e) {
      const formItemEl = $(e.target).closest(".ds-form-item");
      if (formItemEl) {
        const vm = formItemEl[0].__vue__;
        const metadata = vm.metadata;
        this.$dispatch("dblclickFormItem", metadata);
      }
    },
  },
  watch: {},
  mounted() {
    // this.init();
  },
});
</script>